const HTML_ENTITIES: Record<string, string> = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#039;",
};

/**
 * Product descriptions are rendered as HTML. Prefix the listing title so
 * every item has useful description content while escaping title text before
 * it enters the HTML body.
 */
export const buildItemDescription = (
  itemTitle: string | null | undefined,
  descriptionBody: string | null | undefined
): string => {
  const titleText = itemTitle?.trim() || "";
  const body = descriptionBody?.trim() || "";
  const escapedTitle = titleText.replace(
    /[&<>"']/g,
    (character) => HTML_ENTITIES[character] ?? character
  );

  if (!escapedTitle) return body;
  return body ? `${escapedTitle}<br /><br />${body}` : escapedTitle;
};
